/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 11:15:10 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { FreeIcon } from "theme/icons";
import { EmphasisText } from "ui-widgets";
import { usePurchaseFlowStrategy } from "./usePurchaseFlowStrategy";
import { useSubscribeWithoutPay } from "./useSubscribeWithoutPay";

export const useFreePurchaseFlowStrategy: typeof usePurchaseFlowStrategy = () => {
  const parentStrategy = usePurchaseFlowStrategy();

  return {
    ...parentStrategy,
    getPurchaseFormTitle: (plan) => "Free forever",
    getPurchaseFormIcon: (plan) => <FreeIcon height={50} width={50} />,
    getPurchaseFormBody: (args) => (
      <Stack spacing={2}>
        <Typography variant="body1" color="gray">
          You have chosen the <EmphasisText color={"rgb(105,105,105)"}>Free</EmphasisText> plan. The plan is free
          forever. You can upgrade to any other plan at any time to take advantage of more advanced features in Onestop.
        </Typography>
      </Stack>
    ),
    getPurchaseCTA: ({ onClickPlan, subscriptionPlan }) => (
      <Button
        onClick={onClickPlan}
        fullWidth
        size="large"
        variant="contained"
        sx={{ backgroundColor: parentStrategy.getWidgets(subscriptionPlan).packageColor }}
      >
        Get Free Plan
      </Button>
    ),
    useHandlePurchase: ({ selectedOrganization }) => {
      return { ...useSubscribeWithoutPay(selectedOrganization, 0) };
    },
  };
};
